module.exports = __webpack_public_path__ + "img/thermometer-img2-1.c9c44010.png";